import type { Layout } from "react-grid-layout"

interface UpdateCellHeightPayload {
  id: string
  h: number
}

export type LayoutActionT = {
  type: "UPDATE_CELL_HEIGHT"
  payload: UpdateCellHeightPayload
}

type DashboardLayoutT = {
  [key: string]: Layout
}

export const layoutReducer = (layout: DashboardLayoutT, action: LayoutActionT) => {
  switch (action.type) {
    case "UPDATE_CELL_HEIGHT": {
      const cell = layout[action.payload.id]
      if (cell?.h === action.payload.h) return layout
      return {
        ...layout,
        [action.payload.id]: { ...cell, h: action.payload.h },
      }
    }
    default:
      return layout
  }
}
